import { UserRole } from '@fly/shared';
import { apiSlice } from '@fly/store';

export interface ProfileData {
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  isPasswordSet: boolean;
  isAdmin: boolean;
  accountNumber: string;
  isEnrolledToMFA: boolean;
  tenantId: string;
}

export interface UpdateProfileRequest {
  firstName: string;
  lastName: string;
}

export const profileService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUserProfile: builder.query<ProfileData, void>({
      query: () => ({
        url: '/users/me',
        method: 'GET',
      }),
      transformResponse: (response: ProfileData) => ({
        ...response,
        isAdmin: response.role === UserRole.ADMIN,
      }),
      providesTags: ['profile'],
    }),

    updateProfile: builder.mutation<ProfileData, UpdateProfileRequest>({
      query: (data) => ({
        url: '/users/me',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['profile', 'users'],
    }),

    disableMFA: builder.mutation<void, string>({
      query: (token) => ({
        api: 'user',
        url: '/user/v1',
        method: 'PUT',
        data: { enroll_to_mfa: false },
        config: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      }),
      invalidatesTags: ['profile', 'users'],
    }),
  }),
});

export const {
  useGetCurrentUserProfileQuery,
  useUpdateProfileMutation,
  useDisableMFAMutation,
} = profileService;
